import Icon, { IconType } from "@edaz/edazkit/Icon";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Alert } from "react-bootstrap";
import { PersistedBase64 } from "../../../../models/notice";

const FilesList: FunctionComponent<{
  files: PersistedBase64[];
  removeFile: (file: PersistedBase64) => () => void;
}> = observer(({ files, removeFile }) => {
  return (
    <>
      {files.map((file: PersistedBase64, index: number) => (
        <Alert
          key={`${file.fileName}-${index}`}
          variant="info"
          className="d-flex justify-content-between align-items-center mb-2 text-shadow-none py-3 font-weight-bold">
          <span className="text-break pr-3">{file.fileName}</span>
          <div>
            <Icon onClick={removeFile(file)} icon={IconType.Cross} width={12} height={12} style={{ cursor: "pointer" }} />
          </div>
        </Alert>
      ))}
    </>
  );
});

export default FilesList;
